import { useBoolean } from '@insta-club/hooks';
import { Algoritm, Guides } from '@insta-club/models';
import { t } from '@insta-club/translations';
import { Checkbox, CustomCollapse, GuideDialog } from '@insta-club/ui';
import { useMemo, useState } from 'react';
import AlgorithmicProgram from './program';

interface Props {
    algorithms?: Algoritm[];
    programID: number;
    dayNumber: number;
    canPerformTask: boolean;
}

const AlgorithmicTask: React.FC<Props> = ({ algorithms, programID, dayNumber, canPerformTask }) => {
    const sheet = useBoolean();
    const [guide, setGuide] = useState<Guides>();

    const openGuide = (guide: Guides) => {
        sheet.onFalse();
        setTimeout(() => {
            setGuide(guide);
        }, 300);
    };

    const closeGuide = () => {
        setGuide(undefined);
        sheet.onTrue();
    };

    const { isDone, pendingCount } = useMemo(() => {
        const pending = algorithms?.filter((task) => !task.is_done).length ?? 0;
        return {
            isDone: algorithms?.length && pending === 0,
            pendingCount: pending
        };
    }, [algorithms]);

    // const handleCloseSheet = () => {
    //     sheet.onFalse();
    //     mutate(ApiKeys.GET_PROGRAM_SHOW(programID, dayNumber));
    // };

    const disabled = !algorithms || algorithms.length === 0;
    const description = disabled
        ? `در این روز ☕ هیچ برنامه ${t('algorithmic')} ندارید`
        : pendingCount > 0
          ? `${pendingCount} فعالیت الگوریتمی برای انجام دارید`
          : 'تکمیل شده';
    // const status = isDone ? 'done' : 'progress';

    return (
        <>
            <section className='space-y-3.5'>
                <CustomCollapse
                    disabledToggle={!algorithms}
                    contentBgColor='bg-gray-50'
                    titleClassName='w-full'
                    borderClassName='border-transparent'
                    headerBgColor='bg-gray-100'
                    // headerBgColor={cn({
                    //     'bg-gray-100': !isDone,
                    //     'bg-success-50': isDone
                    // })}
                    title={
                        <div className='flex items-center justify-between pl-3'>
                            <div className='text-primary-900 flex flex-col items-start space-y-1 text-base font-bold'>
                                <div className='flex items-center space-x-1'>
                                    <span>برنامه</span>
                                    <span className={isDone ? 'text-success-500' : ''}>{t('algorithmic')}</span>
                                    {isDone && <Checkbox checked color='green' readOnly disabled />}
                                </div>
                                <p className='text-right text-sm font-normal text-gray-600'>{description}</p>
                            </div>
                            {/* {algorithms && (
                                <div className='text-sm font-medium text-gray-600'>
                                    {!isDone && (
                                        <>
                                            ({algorithms?.length} / {algorithms?.length - pendingCount})
                                        </>
                                    )}
                                </div>
                            )} */}
                        </div>
                    }
                >
                    {algorithms ? (
                        <>
                            <div className='mb-4'>
                                <div className='flex items-center text-sm font-normal text-gray-600'>
                                    {canPerformTask ? (
                                        <>برای ثبت فعالیتت، بعد از انجامش تیک بزن</>
                                    ) : (
                                        'وضعیت تسک‌های برنامه تنها در همان روز یا روز بعد قابل به‌روزرسانی است.'
                                    )}
                                </div>
                            </div>

                            <AlgorithmicProgram
                                // onGuide={openGuide}
                                onGuideTask={openGuide}
                                programID={programID}
                                dayNumber={dayNumber}
                                algorithms={algorithms}
                                canPerformTask={canPerformTask}
                            />
                        </>
                    ) : (
                        <>ندارد</>
                    )}
                </CustomCollapse>
            </section>
            {/* <ProgramCategory
                title={t('program', t('algorithmic'))}
                description={pendingCount > 0 ? `${pendingCount} فعالیت الگوریتمی برای انجام دارید` : 'تکمیل شده'}
                status={isDone ? 'done' : 'progress'}
                onClick={sheet.onTrue}
                disabled={!algorithms || algorithms.length === 0}
            /> */}
            {/* {algorithms ? (
                <BottomSheet
                    title={`${t('program')} ${t('algorithmic')}`}
                    open={sheet.value}
                    onClose={handleCloseSheet}
                >
                    <AlgorithmicProgram
                        onGuide={openGuide}
                        onGuideTask={openGuide}
                        programID={programID}
                        dayNumber={dayNumber}
                        algorithms={algorithms}
                        canPerformTask={canPerformTask}
                    />
                </BottomSheet>
            ) : null} */}
            <GuideDialog open={guide !== undefined} onClose={closeGuide} guide={guide} />
        </>
    );
};

export default AlgorithmicTask;

